import { searchOrganisationUsers } from '@infuse/api/iam/organisation';
import { useGenericUsers } from '@infuse/iam/user/queries';

export const useOrganisationUsers = () =>
  useGenericUsers({
    apiFn: searchOrganisationUsers,
    queryKeys: ['users', 'organisation'],
    onlyEnableWithParentId: true
  });
